
export default {
    namespaced: true,
    state: {
        modal: {
            show: false,
            size: "sm",
            hideHeader: true,
            hideFooter: true,
            component: '',
            data: {},
        },
        sidebar: {
            show: false,
            noHeader: true,
            data: {},
            component: '',
        },
        sidebarComponent: null,
        projectSidebar: {
            show: false,
            data: {},
            component: null,
            align: 'left',
            heading: null,
            key: 'sidebar',
            props: {}
        }
    },
    actions: {
        'modal'({commit, state}, value){
            let modal = {
                ...state.modal,
                ...value
            }
            commit('MODAL', modal)
        },
        'modal.data'({ commit}, value){
            commit('MODAL_DATA', value)
        },
        'modal.close'({commit, state}){
            const args = {
                show: false,
                size: "sm",
                hideHeader: true,
                hideFooter: true,
                component: ''
            }
            commit('MODAL', {
                ...state.modal,
                ...args
            })
        },
        setSidebarComponent({commit}, value){
            commit('SIDEBAR_COMPONENT', value)
        },
        'projectSidebar.open'({commit, state}, value){
            let sidebar = {
                ...state.projectSidebar,
                ...value,
                ...{ show: true }
            }

            commit('PROJECT_SIDEBAR', sidebar)
        },
        'projectSidebar.close'({commit, state}, value){
            let sidebar = {
                ...state.projectSidebar,
                ...{ show: false }
            }
            commit('PROJECT_SIDEBAR', sidebar)
        }

    },
    mutations: {
        MODAL: (state, value) => state.modal = value,
        MODAL_DATA: (state, value) => state.modal.data = value,
        SIDEBAR: (state, value) => state.sidebar = value,
        SIDEBAR_DATA: (state, value) => state.sidebar.data = value,
        SIDEBAR_COMPONENT: (state,value) => state.sidebarComponent = value,
        PROJECT_SIDEBAR: (state,value) => state.projectSidebar = value
    },
    getters: {
        'modal': (state) => state.modal,       
        'modal.data': state => state.modal.data,
        'sidebar': (state) => state.sidebar,       
        'sidebar.data': state => state.sidebar.data,
        sidebarComponent: (state) => state.sidebarComponent,
        projectSidebar: (state) => state.projectSidebar,
    }
}